"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ImageUpload;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRainbowComponents = require("react-rainbow-components");

var _hooks = require("./hooks");

var _styled = require("./styled");

function ImageUpload(props) {
  var path = props.path,
      image = props.image,
      onUploaded = props.onUploaded,
      onError = props.onError;
  var storageRef = (0, _hooks.useStorageRef)();

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      progress = _useState2[0],
      setProgress = _useState2[1];

  (0, _react.useEffect)(function () {
    var uploadTask = storageRef.child("".concat(path, "/").concat(image.name)).put(image);
    var unsubscribe = uploadTask.on('state_changed', function (snapshot) {
      var percent = Math.round(snapshot.bytesTransferred / snapshot.totalBytes * 100);
      setProgress(function (previousPercent) {
        return percent > previousPercent ? percent : previousPercent;
      });
    }, function (error) {
      onError(error);
    }, function () {
      onUploaded({
        uploadedImage: image,
        imageRef: uploadTask.snapshot.ref
      });
    });
    return function () {
      unsubscribe();
    };
  }, [image, onError, onUploaded, path, storageRef]);
  return /*#__PURE__*/_react["default"].createElement(_styled.StyledFileContainer, null, /*#__PURE__*/_react["default"].createElement(_styled.StyledContainerImageUpload, null, /*#__PURE__*/_react["default"].createElement(_reactRainbowComponents.ProgressCircular, {
    value: progress
  })));
}

ImageUpload.propTypes = {
  path: _propTypes["default"].string.isRequired,
  image: _propTypes["default"].object.isRequired,
  onUploaded: _propTypes["default"].func,
  onError: _propTypes["default"].func
};
ImageUpload.defaultProps = {
  onUploaded: function onUploaded() {},
  onError: function onError() {}
};